import SvgarCube from './../models/SvgarCube';
import SvgarSlab from './../models/SvgarSlab';
import SvgarPath from './../models/SvgarPath';
export default function Create() {
    const context = {
        svgar: {
            cube: createSvgarCube,
            slab: createSvgarSlab,
            path: new CreateSvgarPathContext(),
        }
    };
    return context;
}
function createSvgarCube(name) {
    return new CreateSvgarCubeContext(name);
}
class CreateSvgarCubeContext {
    constructor(name) {
        this.then = { build: this.build.bind(this) };
        this.name = name;
    }
    build() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let cube = new SvgarCube(this.name);
        cube.slabs = (_a = this.slabs, (_a !== null && _a !== void 0 ? _a : []));
        cube.scope = {
            minimum: [(_c = (_b = this.camera) === null || _b === void 0 ? void 0 : _b[0], (_c !== null && _c !== void 0 ? _c : 0)), (_e = (_d = this.camera) === null || _d === void 0 ? void 0 : _d[1], (_e !== null && _e !== void 0 ? _e : 0))],
            maximum: [(_g = (_f = this.camera) === null || _f === void 0 ? void 0 : _f[2], (_g !== null && _g !== void 0 ? _g : 1)), (_j = (_h = this.camera) === null || _h === void 0 ? void 0 : _h[3], (_j !== null && _j !== void 0 ? _j : 1))]
        };
        return cube;
    }
    withSlabs(slabs) {
        this.slabs = slabs;
        return this;
    }
    withCameraExtents(xMin, yMin, xMax, yMax) {
        this.camera = [xMin, yMin, xMax, yMax];
        return this;
    }
}
function createSvgarSlab(name) {
    return new CreateSvgarSlabContext(name);
}
class CreateSvgarSlabContext {
    constructor(name) {
        this.then = { build: this.build.bind(this) };
        this.name = name;
    }
    build() {
        let slab = new SvgarSlab(this.name);
        if (this.id)
            slab.newId(this.id);
        if (this.elevation)
            slab.setElevation(this.elevation);
        if (this.states)
            slab.setAllStates(this.states);
        if (this.styles)
            slab.setAllStyles(this.styles);
        if (this.localStyle)
            slab.setLocalStyle(this.localStyle);
        if (this.clip)
            slab.clipWith(this.clip);
        if (this.mask)
            slab.maskWith(this.mask);
        return slab;
    }
    withId(id) {
        this.id = id;
        return this;
    }
    withElevation(elevation) {
        this.elevation = elevation;
        return this;
    }
    withStates(states) {
        this.states = states;
        return this;
    }
    withStyles(styles) {
        this.styles = styles;
        return this;
    }
    withLocalStyle(style) {
        this.localStyle = style;
        return this;
    }
    withClipPath(clipPath) {
        this.clip = clipPath;
        return this;
    }
    withMask(mask) {
        this.mask = mask;
        return this;
    }
}
class CreateSvgarPathContext {
    constructor() {
        this.events = {};
        this.then = { build: this.build.bind(this) };
        this.from = {
            polyline: this.fromPolyline.bind(this),
            circle: this.fromCircle.bind(this),
            curve: this.fromCurve.bind(this),
            paths: this.joinPaths.bind(this)
        };
    }
    build() {
        var _a;
        let path = new SvgarPath((_a = this.coordinates, (_a !== null && _a !== void 0 ? _a : [])));
        if (this.tag)
            path.setTag(this.tag);
        if (this.id)
            path.newId(this.id);
        if (this.elevation)
            path.setElevation(this.elevation);
        Object.keys(this.events).forEach(x => {
            path.attach(x, this.events[x]);
        });
        return path;
    }
    fromBuilder(builder) {
        this.coordinates = builder.build().getCoordinates();
        return this.build();
    }
    fromPolyline(builder) {
        return this.fromBuilder(builder);
    }
    fromCircle(builder) {
        return this.fromBuilder(builder);
    }
    fromCurve(builder) {
        return this.fromBuilder(builder);
    }
    joinPaths(paths) {
        return paths;
    }
    withTag(tag) {
        this.tag = tag;
        return this;
    }
    withId(id) {
        this.id = id;
        return this;
    }
    withElevation(elevation) {
        this.elevation = elevation;
        return this;
    }
    withCoordinates(coordinates) {
        this.coordinates = coordinates;
        return this;
    }
    when(event, handler) {
        this.events[event] = handler;
        return this;
    }
}
